import { set } from "firebase/database";
import { useState } from "react";

const FilterBottomSheet = ({ onClose, selectedNiche, setSelectedNiche }) => {
    const [isClosing, setIsClosing] = useState(false);
    const [localSelectedNiche, setLocalSelectedNiche] = useState(selectedNiche);

    const niches = ["all", "Filmmaker", "Content Creator", "Drone Operator", "Gaffer", "Sound Designer", "VFX Artist", "Editor"];

    const handleClose = () => {
        setSelectedNiche(localSelectedNiche);
        setIsClosing(true);
        setTimeout(() => {
            onClose();
        }, 300); // match animation duration
    };

    return (
        <div
            className="fixed inset-0 z-50 flex items-end justify-center bg-black/50 backdrop-blur-sm"
            onClick={handleClose}
        >
            <div
                onClick={(e) => e.stopPropagation()}
                className={`w-full md:w-[90%] lg:w-[70%] max-w-[900px] 
        bg-white dark:bg-[#1E1E1E] 
        rounded-t-[40px] 
        px-6 md:px-12 pt-8 pb-10 
        shadow-xl transition-transform duration-300
        ${isClosing ? "animate-slide-down" : "animate-slide-up"}`}
            >

                {/* Header */}
                <div className="flex justify-between items-center mb-6">
                    <h2 className="text-xl md:text-2xl font-semibold text-black dark:text-white">
                        Filters
                    </h2>

                    <button
                        onClick={handleClose}
                        className="text-sm text-gray-500 hover:text-gray-700 dark:text-gray-400"
                    >
                        Close
                    </button>
                </div>

                {/* Niche Filter */}
                <div className="text-left">
                    <label className="text-sm text-gray-500 dark:text-gray-400">
                        Niche
                    </label>

                    <div className="relative w-full mt-1">
                        <select
                            value={localSelectedNiche}
                            onChange={(e) => setLocalSelectedNiche(e.target.value)}
                            className="w-full px-4 pr-10 py-3 rounded-xl 
    bg-[#F5F9FE] dark:bg-white 
    text-black 
    border border-gray-200 dark:border-0 
    outline-none appearance-none"
                        >
                            {niches.map((n) => (
                                <option key={n} value={n}>
                                    {n === "all" ? "All Niches" : n}
                                </option>
                            ))}
                        </select>

                        {/* Custom Arrow */}
                        <div className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2">
                            <svg
                                className="w-5 h-5 text-black"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                viewBox="0 0 24 24"
                            >
                                <path d="M6 9l6 6 6-6" />
                            </svg>
                        </div>
                    </div>
                </div>

                {/* Actions */}
                <div className="mt-8 flex gap-3">
                    <button
                        onClick={() => {
                            setLocalSelectedNiche("all");
                            setSelectedNiche("all");
                            setIsClosing(true);
                            setTimeout(() => {
                                onClose();
                            }, 300);
                        }}
                        className="flex-1 py-3 border border-gray-300 rounded-xl 
            text-gray-700 dark:text-gray-300"
                    >
                        Reset
                    </button>

                    <button
                        onClick={() => {
                            handleClose();
                        }}
                        className="flex-1 py-3 bg-[#327691] text-white rounded-xl font-semibold"
                    >
                        Apply Filters
                    </button>
                </div>
            </div>
        </div>
    );
};

export default FilterBottomSheet;